import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import {
  AppBar,
  Grid,
  LinearProgress,
  Tab,
  Tabs,
} from '@material-ui/core';
import { 
  renderSnackbarError,
} from '../form-global-components/components-form-components-for-react-final-form';
import {
  ButtonSave,
  ButtonSaveAndClose,
} from 'theme';
import Save from '@material-ui/icons/Save';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import asyncValidate from './components/asyncValidate';

import { TabContainer } from '../custom-tab-container/custom-tab-container';

import EditViewPostDischargeTabName from './components/tab-name';
import EditViewPostDischargeTabDates from './components/tab-dates';
import EditViewPostDischargeTabAddress from './components/tab-address';

import EditViewPostDischargeTabPostDischargeStatus from './components/tab-post-discharge';

import EditViewPostDischargeTabIntakeAssessment from './components/tab-intake-assessment';
import EditViewPostDischargeTabResidentialCMPrograms from './components/tab-residential-cm-programs';
import EditViewPostDischargeTabVoluntaryProgramActivity from './components/tab-voluntary-program-activity';
import EditViewPostDischargeTabDischargeTermination from './components/tab-discharge-termination';

import EditViewPostDischargeTabPrograms from './components/tab-programs';
import EditViewPostDischargeTabClientDetails from './components/tab-client-details';
import EditViewPostDischargeTabOutcome from './components/tab-outcome';
import EditViewPostDischargeTabChangeLog from './components/tab-changelog';
  /*** signed in user */
  import  CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'

class PostDischargeEdit extends Component {  
  /*** signed in user */
  static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  

  constructor(props) {
    super(props);
    this.state = {
      headerTabs: 0,
      subHeaderTabs1: 1,
      radio1Change: 0,
      select1Change: 0,
    };
  }
  componentDidUpdate() {
    /*** fix double render issue - start */
		if(this.props.match.params.id && !this.props.initialized)
			this.props.initialize(this.props.initialValues);
    /*** fix double render issue - end */
  }
  componentDidMount() {
    /*** fix double render issue - start */
    this.props.initialize(this.props.initialValues);
    /*** fix double render issue - end */
  }

  handleChangeHeader1 = (event, value) => {
    event.persist();
    this.setState({ headerTabs: value });
  }

  handleSubmitSave = () => {
                  /*** signed in user */
                  const c_USER = this.context  

    var params = {
      /*** tab-address */
      'street': this.props.currentFormState.street,
      'city': this.props.currentFormState.city,
      'state': this.props.currentFormState.state,
      'zip': this.props.currentFormState.zip,
      
      'phonenumber': this.props.currentFormState.phonenumber,
      'emergencycontact': this.props.currentFormState.emergencycontact,
      'emergencycontactnumber': this.props.currentFormState.emergencycontactnumber,

      /*** Post Discharge Tabs Post Discharge Status */
      'postdischargeclientdischargedate': this.props.currentFormState.clientdischargedate,

      'postdischargecontactdate90d': this.props.currentFormState.postdischargecontactdate90d,
      'postdischargecontactdate180d': this.props.currentFormState.postdischargecontactdate180d,
      'postdischargecontactdate12m': this.props.currentFormState.postdischargecontactdate12m,
      'postdischargecontactdate24m': this.props.currentFormState.postdischargecontactdate24m,
      'postdischargecontactdate36m': this.props.currentFormState.postdischargecontactdate36m,
      
      
      'postdischargeattemptedcontact90desults': this.props.currentFormState.postdischargeattemptedcontact90desults,
      'postdischargeattemptedcontact180dresults': this.props.currentFormState.postdischargeattemptedcontact180dresults,
      'postdischargeattemptedcontact12mresults': this.props.currentFormState.postdischargeattemptedcontact12mresults,
      'postdischargeattemptedcontact24mresults': this.props.currentFormState.postdischargeattemptedcontact24mresults,
      'postdischargeattemptedcontact36mresults': this.props.currentFormState.postdischargeattemptedcontact36mresults,
      
      
      'postdischargesincedischargephysicalvisitstoer': this.props.currentFormState.postdischargesincedischargephysicalvisitstoer,
      'postdischargesincedischargephysicalvisitstoerrefusedtoanswer': this.props.currentFormState.postdischargesincedischargephysicalvisitstoerrefusedtoanswer,
      'postdischargesincedischargementalvisitstoer': this.props.currentFormState.postdischargesincedischargementalvisitstoer,
      'postdischargesincedischargementalvisitstoerrefusedtoanswer': this.props.currentFormState.postdischargesincedischargementalvisitstoerrefusedtoanswer,
      'postdischargesincedischargephysicalhospadmissions': this.props.currentFormState.postdischargesincedischargephysicalhospadmissions,
      'postdischargesincedischargephysicalhospadmissionsrefusedtoanswer': this.props.currentFormState.postdischargesincedischargephysicalhospadmissionsrefusedtoanswer,
      'postdischargesincedischargementalhospadmissions': this.props.currentFormState.postdischargesincedischargementalhospadmissions,
      'postdischargesincedischargementalhospadmissionsrefusedtoanswer': this.props.currentFormState.postdischargesincedischargementalhospadmissionsrefusedtoanswer,
      'postdischargesincedischargetimesinjail': this.props.currentFormState.postdischargesincedischargetimesinjail,
      'postdischargesincedischargetimesinjailrefusedtoanswer': this.props.currentFormState.postdischargesincedischargetimesinjailrefusedtoanswer,
      'postdischargesincedischargelongeststayinjail': this.props.currentFormState.postdischargesincedischargelongeststayinjail,
      'postdischargesincedischargelongeststayinjailrefusedtoanswer': this.props.currentFormState.postdischargesincedischargelongeststayinjailrefusedtoanswer,
      'postdischargesincedischargeovernighthospstay': this.props.currentFormState.postdischargesincedischargeovernighthospstay,
      'postdischargesincedischargeovernighthospstayrefusedtoanswer': this.props.currentFormState.postdischargesincedischargeovernighthospstayrefusedtoanswer,
      
      'postdischargehousingsincedischarge': this.props.currentFormState.postdischargehousingsincedischarge,
      'postdischargeemployedsincedischarge': this.props.currentFormState.postdischargeemployedsincedischarge,
      'postdischargesubstanceuse': this.props.currentFormState.postdischargesubstanceuse,

      'postdischargeeduachvmntchanges': this.props.currentFormState.postdischargeeduachvmntchanges,
      'postdischargefamilynsigothers': this.props.currentFormState.postdischargefamilynsigothers,
      
      'postdischargecounselingsupportrefusedtoanswer': this.props.currentFormState.postdischargecounselingsupportrefusedtoanswer,
      'postdischargecounselingsupportmedication': this.props.currentFormState.postdischargecounselingsupportmedication,
      'postdischargecounselingsupportcounseling': this.props.currentFormState.postdischargecounselingsupportcounseling,
      'postdischargecounselingsupportcasemanagement': this.props.currentFormState.postdischargecounselingsupportcasemanagement,
      'postdischargecounselingsupportsupportgroup': this.props.currentFormState.postdischargecounselingsupportsupportgroup,
      
      'postdischargerateyourqualityoflife': this.props.currentFormState.postdischargerateyourqualityoflife,
      
      'postdischargechildhospital': this.props.currentFormState.postdischargechildhospital,
      'postdischargearrestfree': this.props.currentFormState.postdischargearrestfree,
      
      'postdischargestatuscomments': this.props.currentFormState.postdischargestatuscomments,

      // 'postdischargelasttouchedbyloginid': this.props.currentUser.id,
      'postdischargelasttouchedbyloginid': c_USER.id,
    };

                                                                            // console.log ('4444-304-890 - EditViewPostDischarge-AAA - handleSubmitSave - params = ', params);

    this.props.editPostDischargeSave(this.props.match.params.id, params);
  }


  handleSubmitSaveAndClose = (values, reset, dispatch) => {
                                                                          // console.log('GGG - 3333-555 - EditViewPostDischarge - handleSubmitSaveAndClose - values ', values);


    /*** signed in user */
    const c_USER = this.context  

    var params = {
      /*** tab-address */
      'street': values.street,
      'city': values.city,
      'state': values.state,
      'zip': values.zip,

      'phonenumber': values.phonenumber,
      'emergencycontact': values.emergencycontact,
      'emergencycontactnumber': values.emergencycontactnumber,

      /*** Post Discharge Tabs Post Discharge Status */
      'postdischargeclientdischargedate': values.clientdischargedate,

      'postdischargecontactdate90d': values.postdischargecontactdate90d,
      'postdischargecontactdate180d': values.postdischargecontactdate180d,
      'postdischargecontactdate12m': values.postdischargecontactdate12m,
      'postdischargecontactdate24m': values.postdischargecontactdate24m,
      'postdischargecontactdate36m': values.postdischargecontactdate36m,
      
      
      'postdischargeattemptedcontact90desults': values.postdischargeattemptedcontact90desults,
      'postdischargeattemptedcontact180dresults': values.postdischargeattemptedcontact180dresults,
      'postdischargeattemptedcontact12mresults': values.postdischargeattemptedcontact12mresults,
      'postdischargeattemptedcontact24mresults': values.postdischargeattemptedcontact24mresults,
      'postdischargeattemptedcontact36mresults': values.postdischargeattemptedcontact36mresults,
      
      
      'postdischargesincedischargephysicalvisitstoer': values.postdischargesincedischargephysicalvisitstoer,
      'postdischargesincedischargephysicalvisitstoerrefusedtoanswer': values.postdischargesincedischargephysicalvisitstoerrefusedtoanswer,
      'postdischargesincedischargementalvisitstoer': values.postdischargesincedischargementalvisitstoer,
      'postdischargesincedischargementalvisitstoerrefusedtoanswer': values.postdischargesincedischargementalvisitstoerrefusedtoanswer,
      'postdischargesincedischargephysicalhospadmissions': values.postdischargesincedischargephysicalhospadmissions,
      'postdischargesincedischargephysicalhospadmissionsrefusedtoanswer': values.postdischargesincedischargephysicalhospadmissionsrefusedtoanswer,
      'postdischargesincedischargementalhospadmissions': values.postdischargesincedischargementalhospadmissions,
      'postdischargesincedischargementalhospadmissionsrefusedtoanswer': values.postdischargesincedischargementalhospadmissionsrefusedtoanswer,
      'postdischargesincedischargetimesinjail': values.postdischargesincedischargetimesinjail,
      'postdischargesincedischargetimesinjailrefusedtoanswer': values.postdischargesincedischargetimesinjailrefusedtoanswer,
      'postdischargesincedischargelongeststayinjail': values.postdischargesincedischargelongeststayinjail,
      'postdischargesincedischargelongeststayinjailrefusedtoanswer': values.postdischargesincedischargelongeststayinjailrefusedtoanswer,
      'postdischargesincedischargeovernighthospstay': values.postdischargesincedischargeovernighthospstay,
      'postdischargesincedischargeovernighthospstayrefusedtoanswer': values.postdischargesincedischargeovernighthospstayrefusedtoanswer,
      
      'postdischargehousingsincedischarge': values.postdischargehousingsincedischarge,
      'postdischargeemployedsincedischarge': values.postdischargeemployedsincedischarge,
      'postdischargesubstanceuse': values.postdischargesubstanceuse,

      'postdischargeeduachvmntchanges': this.props.currentFormState.postdischargeeduachvmntchanges,
      'postdischargefamilynsigothers': this.props.currentFormState.postdischargefamilynsigothers,
      
      'postdischargecounselingsupportrefusedtoanswer': values.postdischargecounselingsupportrefusedtoanswer,
      'postdischargecounselingsupportmedication': values.postdischargecounselingsupportmedication,
      'postdischargecounselingsupportcounseling': values.postdischargecounselingsupportcounseling,
      'postdischargecounselingsupportcasemanagement': values.postdischargecounselingsupportcasemanagement,
      'postdischargecounselingsupportsupportgroup': values.postdischargecounselingsupportsupportgroup,
      
      'postdischargerateyourqualityoflife': values.postdischargerateyourqualityoflife,

      'postdischargechildhospital': values.postdischargechildhospital,
      'postdischargearrestfree': values.postdischargearrestfree,

      'postdischargestatuscomments': values.postdischargestatuscomments,

      // 'postdischargelasttouchedbyloginid': this.props.currentUser.id,
      'postdischargelasttouchedbyloginid': c_USER.id,
    };

                                                                                        // console.log ('4444-304-890 - EditViewPostDischarge-AAA - handleSubmitSaveAndClose - params = ', params);

      if (this.props.postdischargeMode === 0) {
                                                                                        // console.log ('4444-304-896 - EditViewPostDischarge-AAA - handleSubmitSaveAndClose - no no NO NO ');
        this.props.addPostDischarge(params);
      }else {
          if (
              values.postdischargecontactdate36m
              ||
              values.postdischargeattemptedcontact90desults === '10'
              ||
              values.postdischargeattemptedcontact180dresults === '10'
              ||
              values.postdischargeattemptedcontact12mresults === '10'
              ||
              values.postdischargeattemptedcontact24mresults === '10'
              ||
              values.postdischargeattemptedcontact36mresults === '10'
            ) {
            this.props.archivePostDischarge(this.props.match.params.id, params);
          } else {
            this.props.editPostDischargeSaveAndClose(this.props.match.params.id, params);
          }
      }
  }


  render() {

                                                                                  // console.log ('4444-4234 - PostDischargeEdit - Props = ', this.props);
                                                                                  // console.log ('4444-4235 - PostDischargeEdit - State = ', this.state);
                                                                                  // console.log ('4444-4236 - PostDischargeEdit - this.props.valid = ', this.props.valid);



                                                                                  // console.log ('4444-3413 - PostDischargeEdit - Props = ', this.props);
                                                                                  // if (typeof this.props.postdischarge === "undefined")
                                                                                  // {} else { 
                                                                                  //   // console.log ('4444-3415 - PostDischargeEdit - Props.singleTest = ', this.props.postdischarge.dob );
                                                                                  //   console.log ('4444-3415 - PostDischargeEdit - Props.singleTest = ', new Date(this.props.postdischarge.dob) );
                                                                                  // }

    return (
      <form onSubmit={this.props.handleSubmit(this.handleSubmitSaveAndClose)}>
        <div >
          <AppBar position="static" color="default">

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <ButtonSave
                size='large'
                fullWidth
                onClick={() => {
                  this.handleSubmitSave()
                }}
                disabled={!this.props.valid || this.props.postdischargeMode === 3}
              >
                <Save />
                &nbsp;
                Save
              </ButtonSave>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ButtonSaveAndClose
                type='submit'
                size='large'
                fullWidth
                disabled={!this.props.valid || this.props.postdischargeMode === 3}
              >
                <SaveAltIcon />
                &nbsp;
                Save & Close
              </ButtonSaveAndClose>
            </Grid>
          </Grid> 

          {this.props.loadingList && <LinearProgress variant="buffer"  value={5} valueBuffer={10} color="secondary" /> }

            <Tabs
              value={this.state.headerTabs}
              onChange={this.handleChangeHeader1}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
                                                                                                  // scrollButtons="auto"
              scrollButtons="on"
            >

              <Tab label="Name" />

              <Tab label="Post Discharge Status" />

              <Tab label="Programs" />
              <Tab label="All Program Details" />

              <Tab label="Intake & Assessment" />
              <Tab label="Crosspoint Programing" />
              <Tab label="Voluntary Program Activities" />
              <Tab label="Discharge / Termination" />

              <Tab label="Dates" />
              <Tab label="Referral Outcome" />
              <Tab label="Change Log" />
            </Tabs>
          </AppBar> 



          <Field
              component={renderSnackbarError}
              id='notifyFormErrors'
              name='notifyFormErrors'
            />



          {this.state.headerTabs === 0 && <TabContainer>
            <EditViewPostDischargeTabName
              locked={true}
            />
            <EditViewPostDischargeTabAddress
              locked={this.props.postdischargeMode === 3 ? true : false}
            />            
          </TabContainer>} 

          {this.state.headerTabs === 1 && <TabContainer>
            <EditViewPostDischargeTabPostDischargeStatus
              locked={this.props.postdischargeMode === 3 ? true : false}
              postdischargecontactdate90dSelected={this.props.currentFormState === undefined ? this.props.initialValues.postdischargecontactdate90d : this.props.currentFormState.postdischargecontactdate90d}
              postdischargecontactdate180dSelected={this.props.currentFormState === undefined ? this.props.initialValues.postdischargecontactdate180d : this.props.currentFormState.postdischargecontactdate180d}
              postdischargecontactdate12mSelected={this.props.currentFormState === undefined ? this.props.initialValues.postdischargecontactdate12m : this.props.currentFormState.postdischargecontactdate12m}
              postdischargecontactdate24mSelected={this.props.currentFormState === undefined ? this.props.initialValues.postdischargecontactdate24m : this.props.currentFormState.postdischargecontactdate24m}
            />
          </TabContainer>}

          {this.state.headerTabs === 2 && <TabContainer>
            <EditViewPostDischargeTabPrograms
              locked={true}
              programSelected={this.props.currentFormState === undefined ? this.props.initialValues.program : this.props.currentFormState.program}

              programsList={this.props.programsList.programs}
              // bopinstitutionsList={this.props.bopinstitutionsList.bopinstitutions}
              // gangaffiliationsList={this.props.gangaffiliationsList.gangaffiliations}
              bopinstitutionsList={this.props.bopinstitutionsList}
              gangaffiliationsList={this.props.gangaffiliationsList}

              allowChangeProgram={false}
            /> 
          </TabContainer>}

          {this.state.headerTabs === 3 && <TabContainer>
            <EditViewPostDischargeTabClientDetails
              locked={true}
              // referralsourcesList={this.props.referralsourcesList.referralsources}
              referralsourcesList={this.props.referralsourcesList}
            />
          </TabContainer>}

          {this.state.headerTabs === 4 && <TabContainer>
            <EditViewPostDischargeTabIntakeAssessment
              locked={true}
              programSelected={this.props.initialValues.program}
            />
          </TabContainer>}

          {this.state.headerTabs === 5 && <TabContainer>
            <EditViewPostDischargeTabResidentialCMPrograms
              locked={true}
            />
          </TabContainer>}

          {this.state.headerTabs === 6 && <TabContainer>
            <EditViewPostDischargeTabVoluntaryProgramActivity
              locked={true}
            />
          </TabContainer>}
          
          {this.state.headerTabs === 7 && <TabContainer>
            <EditViewPostDischargeTabDischargeTermination
              locked={true}
              programSelected={this.props.initialValues.program}
              clientdischargedateSelected={this.props.currentFormState === undefined ? this.props.initialValues.clientdischargedate : this.props.currentFormState.clientdischargedate}
            />
          </TabContainer>} 

          {this.state.headerTabs === 8 && <TabContainer>
            <EditViewPostDischargeTabDates
              locked={true}
              referraloutcome={this.props.initialValues.referraloutcome}

              clientdischargestatus={this.props.initialValues.clientdischargestatus} 

              postdischargeattemptedcontact90desults={this.props.initialValues.postdischargeattemptedcontact90desults} 
              postdischargeattemptedcontact180dresults={this.props.initialValues.postdischargeattemptedcontact180dresults} 
              postdischargeattemptedcontact12mresults={this.props.initialValues.postdischargeattemptedcontact12mresults} 
              postdischargeattemptedcontact24mresults={this.props.initialValues.postdischargeattemptedcontact24mresults} 
              postdischargeattemptedcontact36mresults={this.props.initialValues.postdischargeattemptedcontact36mresults} 
            />
          </TabContainer>}

          {this.state.headerTabs === 9 && <TabContainer>
            <EditViewPostDischargeTabOutcome
              locked={true}
            />
          </TabContainer>}

          {this.state.headerTabs === 10 && <TabContainer>
            <EditViewPostDischargeTabChangeLog
            />
          </TabContainer>}

          {this.props.loadingList && <LinearProgress variant="buffer"  value={5} valueBuffer={10} color="secondary" /> }

          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <ButtonSave
                size='large'
                fullWidth
                onClick={() => {
                  this.handleSubmitSave()
                }}
                disabled={!this.props.valid || this.props.postdischargeMode === 3}
              >
                <Save />
                &nbsp;
                Save
              </ButtonSave>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ButtonSaveAndClose
                type='submit'
                size='large'
                fullWidth
                disabled={!this.props.valid || this.props.postdischargeMode === 3}
              >
                <SaveAltIcon />
                &nbsp;
                Save & Close
              </ButtonSaveAndClose>
            </Grid>
          </Grid>

        </div>
      </form>
    );
  }
}
PostDischargeEdit.propTypes = {
  /*** PostDischarge Type - 0 - add - 1 - edit - 2 - view */
  postdischargeMode: PropTypes.number,
  addPostDischarge: PropTypes.func,
  editPostDischargeSave: PropTypes.func,
  editPostDischargeSaveAndClose: PropTypes.func,
  archivePostDischarge: PropTypes.func,
};
PostDischargeEdit = reduxForm({
  form: 'PostDischargeEditForm', // a unique name for this form
  /*** validate form values */
  asyncValidate,
  /*** double render issue */
  enableReinitialize: true,
  // /*** preserve form data */
  // destroyOnUnmount: false,
  // /*** unregister fields on unmount */
  // forceUnregisterOnUnmount: true,
})(PostDischargeEdit);
export default withRouter(PostDischargeEdit);